export default __webpack_public_path__ + "static/media/padellogo.82d78b5d.svg";